import { render } from "./AddTRTPatientModal.vue?vue&type=template&id=9e57498e&scoped=true"
import script from "./AddTRTPatientModal.vue?vue&type=script&lang=js"
export * from "./AddTRTPatientModal.vue?vue&type=script&lang=js"

import "./AddTRTPatientModal.vue?vue&type=style&index=0&id=9e57498e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e57498e"]])

export default __exports__